import React, { useEffect } from 'react';
import { ModularContextProvider } from './context/ModularContext';
import { CustomizerContextProvider } from './context/CustomizerContext';
import { BrowserRouter } from 'react-router-dom';
import RouterMain from './routes/RouterMain';
import { AuthContextProvider } from './context/LocalAuthContext';
import { HealthContextProvider } from './context/HealthContext';
import { TempContextProvider } from './context/TempContext';
import { COD_TAG_MANAGER } from './environments/environment';
import TagManager from 'react-gtm-module';
import { render } from './utils/render';

function App() {
    const tagManagerArgs = { gtmId: render(COD_TAG_MANAGER)}
    useEffect(() => { TagManager.initialize(tagManagerArgs) }, [])
    return (
        <BrowserRouter>
            <HealthContextProvider>
                <ModularContextProvider>
                    <CustomizerContextProvider>
                        <AuthContextProvider>
                            <TempContextProvider>
                                <RouterMain />
                            </TempContextProvider>
                        </AuthContextProvider>
                    </CustomizerContextProvider>
                </ModularContextProvider>
            </HealthContextProvider>
        </BrowserRouter>
    );
}
export default App;
